import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { LanguageRoutingService } from './services/language-routing.service';
import { AuthService } from './services/auth.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet],
  template: `
    <router-outlet></router-outlet>
  `,
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'sameta-fe-jobs';

  constructor(
    private translocoService: TranslocoService,
    private languageRoutingService: LanguageRoutingService,
    private authService: AuthService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngOnInit(): void {
    // Only run on browser side to avoid SSR issues
    if (isPlatformBrowser(this.platformId)) {
      this.initializeLanguage();
      this.refreshUserData();
    }
  }

  /**
   * Refreshes the user data from the server if the user is logged in
   */
  private refreshUserData(): void {
    // Check if user is logged in
    if (this.authService.isLoggedIn()) {
      // Refresh user data from server
      this.authService.refreshCurrentUser().subscribe({
        next: () => {},
        error: (error) => {
          console.error('Error refreshing user data on app initialization:', error);
        }
      });
    }
  }

  private initializeLanguage(): void {
    // Get current language from URL or fallback
    const currentLanguage = this.languageRoutingService.getCurrentLanguage();

    // Set active language in Transloco
    this.translocoService.setActiveLang(currentLanguage);

    // Preload all available languages to avoid SSR fallback warnings
    const availableLanguages = this.translocoService.getAvailableLangs() as string[];
    availableLanguages.forEach((lang) => {
      this.translocoService.load(lang).subscribe();
    });
  }
}
